<template>
    <div>
        <transition appear
                    appear-active-class="fade-enter-active"
                    leave-active-class="fade-leave-active">
            <div>
<p>La dénomination de votre organisme.</p>
<p>Exemple : <b>Office de Tourisme de Grimaud</b></p>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "OrganismField"
    }
</script>
